import { useState } from 'react'
import axios from 'axios'
import { API_CONFIG } from '../config/api.js'

function InviteUser({ onClose }) {
  const [email, setEmail] = useState('')
  const [fullName, setFullName] = useState('')
  const [role, setRole] = useState('user')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [errorType, setErrorType] = useState('') // 'validation' or 'network'
  const [success, setSuccess] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()

    const emailTrim = email.trim()
    const fullNameTrim = fullName.trim()

    if (!emailTrim || !fullNameTrim) {
      setError('Email and full name are required')
      setErrorType('validation')
      return
    }

    if (!emailTrim.toLowerCase().endsWith('@debtregister.com')) {
      setError('Email must be a @debtregister.com address')
      setErrorType('validation')
      return
    }

    setLoading(true)
    setError('')
    setErrorType('')
    setSuccess('')

    try {
      const response = await axios.post(`${API_CONFIG.BASE_URL}/auth/invite`, {
        email: email.trim(),
        full_name: fullName.trim(),
        role
      }, {
        withCredentials: true
      })

      setSuccess(response.data.message || `Invitation sent successfully to ${email}`)

      // Clear form after success
      setTimeout(() => {
        setEmail('')
        setFullName('')
        setRole('user')
        setSuccess('')
        setError('')
        setErrorType('')
        onClose()
      }, 2000)

    } catch (err) {
      // Handle specific validation errors from our validator
      if (err.response?.status === 422) {
        setError(err.response.data.detail)
        setErrorType('validation')
      } else {
        setError(err.response?.data?.detail || err.response?.data?.message || 'Failed to send invitation')
        setErrorType('network')
      }
    } finally {
      setLoading(false)
    }
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal invite-user-modal">
        <div className="modal-header">
          <h3>Invite New User</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && (
              <div className={`error-message ${errorType === 'validation' ? 'validation-error' : 'network-error'}`}>
                {error}
              </div>
            )}

            {success && (
              <div className="success-message">
                {success}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="fullName">Full Name *</label>
              <input
                id="fullName"
                type="text"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                placeholder="Enter full name"
                disabled={loading}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="user@debtregister.com"
                autoComplete="off"
                disabled={loading}
                required
              />
              <small className="form-hint">Must be a @debtregister.com email address</small>
            </div>

            <div className="form-group">
              <label htmlFor="role">Role</label>
              <select
                id="role"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                disabled={loading}
              >
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
              <small className="form-hint">
                Admin users can manage other users and send invitations
              </small>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading || !email || !fullName}
            >
              {loading ? 'Sending...' : 'Send Invitation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default InviteUser